export default [
  {
    component: 'CNavTitle',
    name: 'Dashboard',
  },
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavItem',
    name: 'Saques',
    icon: 'cil-browser',
    to: '/Saques',
  },
  {
    component: 'CNavTitle',
    name: 'Modulos',
  },
  {
    component: 'CNavGroup',
    name: 'Modulos',
    icon: 'cil-browser',
  },
  {
    component: 'CNavItem',
    name: 'Aprovar Premio',
    icon: 'cil-browser',
    to: '/AprovarPremio',
  },
  {
    component: 'CNavItem',
    name: 'Aprovação Automática',
    icon: 'cil-browser',
    to: '/AprovacaoAutomatica',
  },
  {
    component: 'CNavItem',
    name: 'Aprovação Automática',
    icon: 'cil-browser',
    to: '/AprovacaoAutomaticaBichao',
  },
  {
    component: 'CNavItem',
    name: 'Whatsapp Notification',
    icon: 'cil-browser',
    to: '/WhatsappNotification',
  },
  {
    component: 'CNavItem',
    name: 'Monitor Campanhas WhatsApp',
    icon: 'cil-browser',
    to: '/WhatsappCampaignMonitor',
  },
  {
    component: 'CNavItem',
    name: 'Aprovar Premio Bichão',
    icon: 'cil-browser',
    to: '/AprovarPremioBichao',
  },
  {
    component: 'CNavItem',
    name: 'Todos | Fluxo de Caixa',
    icon: 'cil-browser',
    to: '/RelatorioFinanceiro',
  },
  {
    component: 'CNavItem',
    name: 'Todos | Barras',
    icon: 'cil-browser',
    to: '/newbarrar',
  },
  {
    component: 'CNavItem',
    name: 'Todos | FacebookAds',
    icon: 'cil-browser',
    to: '/FacebookAds',
  },
  {
    component: 'CNavItem',
    name: 'Todos | LTV Geral',
    icon: 'cil-browser',
    to: '/ltvgeral',
  },
  {
    component: 'CNavItem',
    name: 'Todos | LTV Cohort',
    icon: 'cil-browser',
    to: '/ltvnew',
  },
  {
    component: 'CNavItem',
    name: 'Todos | Bloquear Consultores',
    icon: 'cil-browser',
    to: '/Consultores',
  },
  {
    component: 'CNavItem',
    name: 'Todos | Relatório de Vendas Semanais',
    icon: 'cil-browser',
    to: '/RelatorioVendasSemanais',
  },
  {
    component: 'CNavItem',
    name: 'Todos | Análise de Faturamento',
    icon: 'cil-browser',
    to: '/Faturamento',
  },
  {
    component: 'CNavItem',
    name: 'Todos | Metas e Vendas',
    icon: 'cil-browser',
    to: '/MetasVendas',
  },
  {
    component: 'CNavItem',
    name: 'Todos | Consultores (exportação)',
    icon: 'cil-browser',
    to: '/ConsultoresExport',
  },
  {
    component: 'CNavItem',
    name: 'Relatório de Depósitos Semanais',
    icon: 'cil-browser',
    to: '/RelatorioDepositosSemanais',
  },
  {
    component: 'CNavItem',
    name: 'Compradores de combo',
    icon: 'cil-browser',
    to: '/ComboBuyersReport',
  },
  {
    component: 'CNavItem',
    name: 'Venda Rápida',
    icon: 'cil-browser',
    to: '/VendaRapidaReport',
  },
  {
    component: 'CNavItem',
    name: 'Saques',
    icon: 'cil-browser',
    to: '/Saques',
  },
  {
    component: 'CNavGroup',
    name: 'Layout',
    icon: 'cil-browser',
    items: [
      {
        component: 'CNavItem',
        name: 'Icones SideBar',
        icon: 'cil-browser',
        to: '/layput/sidebar',
      },
      {
        component: 'CNavItem',
        name: 'Cores Site',
        icon: 'cil-browser',
        to: '/layput/corsite',
      },
      {
        component: 'CNavItem',
        name: 'BtnHome',
        icon: 'cil-browser',
        to: '/layput/btnhome',
      },
    ],
  },
  {
    component: 'CNavItem',
    name: 'Layout | Banners',
    icon: 'cil-browser',
    to: '/Banners',
  },
  {
    component: 'CNavItem',
    name: 'Sua Rifa',
    icon: 'cil-browser',
    to: '/rifa',
  },
]
